Vue.component('logotypes', {
  template: '#vue-logotypes',
  data: function () {
    return {
      agentOfTheYear: {
        img: '',
        alt: '',
        url: ''
      }
    }
  },
  created: function () {
    this.getAgentOfTheYear();
  },
  methods: {
    getAgentOfTheYear: function () {
      const self = this;
      $.post("/back/AgentOfTheYear.php", function (result, textStatus) {
        if (result.img !== null) {
          self.agentOfTheYear.img = result.img;
        }
        if (result.alt !== null) {
          self.agentOfTheYear.alt = result.alt;
        }
        if (result.url !== null) {
          self.agentOfTheYear.url = result.url;
        }
      }, "json");
    }
  }
});
